module.exports = __webpack_public_path__ + "exo-latin-300italic.8d40b499402fd4189be2.woff2";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/typeface-exo/files/exo-latin-300italic.woff2
// module id = ../../../../typeface-exo/files/exo-latin-300italic.woff2
// module chunks = styles